import styled from "styled-components";

export const StyledJobDocumentsPage = styled.div``;